/**
 * 天气模块 store
 */

import axios from "../../utils/axios";

let state = {
  iconBaseUrl: "https://farm-open-datav-xiaomaiot.oss-cn-qingdao.aliyuncs.com/WeatherIcon/weather-icon-S2/256/",
  cityName: "",
  hourlyData: [],
  weatherData: {}
};

let getters = {
  getCityName(state) {
    return state.cityName;
  },
  getHourlyData(state) {
    return state.hourlyData;
  },
  getWeatherData(state) {
    return state.weatherData;
  },
  getIconUrl(state) {
    return state.iconBaseUrl;
  }
};

let mutations = {
  setCityName(state, payload) {
    state.cityName = payload.cityName;
  },
  setWeatherData(state, payload) {
    state.weatherData = payload.weatherData;
  },
  setHourlyData(state, payload) {
    let data = payload.hourlyData.map((item) => {
      return {
        time: item.fxTime.slice(11, 13),
        tem: item.temp
      }
    });
    state.hourlyData = data;
  } 
};

let actions = {
  getWeather({ rootState }) {
    const URL = `/weather/hf?farm_id=${Number(rootState.farmId)}`;
    return axios.get(URL);
  }
};

export default {
  state,
  getters,
  mutations,
  actions
}